import React from 'react';
interface ScreenProps {
  children: React.ReactNode;
  title: string;
  description: string;
}
export const Screen: React.FC<ScreenProps> = ({
  children,
  title,
  description
}) => {
  return <div className="flex flex-col items-center" data-id="element-1572">
      <div className="w-64 h-[500px] bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-200 mb-4" data-id="element-1573">
        <div className="h-6 bg-[#f7f3ef] border-b border-gray-200 flex justify-center items-center" data-id="element-1574">
          <div className="w-24 h-1 bg-gray-300 rounded-full" data-id="element-1575"></div>
        </div>
        <div className="p-4 h-[470px]" data-id="element-1576">{children}</div>
      </div>
      <h3 className="text-lg font-light text-[#333333] mb-1 text-center" data-id="element-1577">
        {title}
      </h3>
      <p className="text-sm text-[#666666] max-w-[250px] text-center" data-id="element-1578">
        {description}
      </p>
    </div>;
};